/**
 * Helpers for session recovery: distinguish signed-in users from anonymous/community.
 */

/** True when the user has a real identity (not community/anonymous). */
export function userHasEppn(user: { eppn?: string } | null | undefined): boolean {
  return Boolean(user?.eppn);
}

export type SessionLostReason = 'inactivity' | 'degraded' | null;
